module.exports = __webpack_public_path__ + "static/media/AH.a762540d.png";